import { useCallback } from 'react';
import { useEntityConfig } from '@/hooks/useEntityConfig.tsx';

export function useNavigateRedirect() {
  const config = useEntityConfig();
  const handleNavigateRedirect = useCallback((): boolean => {
    const urlParams = new URLSearchParams(window.location.search);
    const navigate = urlParams.get('navigate');

    if (navigate === 'tradingview') {
      window.location.href = config.VITE_TRADING_VIEW_URL;

      return true;
    }

    return false;
  }, [config.VITE_TRADING_VIEW_URL]);

  return { handleNavigateRedirect };
}
